import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ItemsList } from './BinPutaway/componentChildren/ItemsList';
import { PlaceItemInfo } from './BinPutaway/componentChildren/PlaceItemInfo';
import './css/Confirm.css';
import './BinPutaway/css/BinPutaway.css';
import { DialogMessage } from './Widgets/DialogMessage';
import { Loader } from './Widgets/Loader';
import { Audio } from './Widgets/Audio';
import { ScanPutawayCart } from './BinPutaway/componentChildren/ScanPutawayCart';
import { ScanItems } from './BinPutaway/componentChildren/ScanItems';
import { ScanPutawayBin } from './BinPutaway/componentChildren/ScanPutawayBin';
export class BinPutaway extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false,
            putawayLocation: {},
            putawayCart: "",
            putawayItem: "",
            putawayBin: "",
            putawayBinId: "",
            putawayQty: 1,
            putawayItems: [],
            selectedPutawayItem: {},
            binTransferId: null,
            stage: "putawayCart"
        }
        this.focusInput = this.focusInput.bind(this);
        this.showConfirm = this.showConfirm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.resetState = this.resetState.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.startLoading = this.startLoading.bind(this);
        this.stopLoading = this.stopLoading.bind(this);
        this.displayError = this.displayError.bind(this);
        this.updateInputValue = this.updateInputValue.bind(this);
        this.scanPutawayCart = this.scanPutawayCart.bind(this);
        this.scanPutawayItem = this.scanPutawayItem.bind(this);
        this.scanPutawayBin = this.scanPutawayBin.bind(this);
        this.getBinItemQty = this.getBinItemQty.bind(this);
        this.putItemInBin = this.putItemInBin.bind(this);
        this.goBackToItems = this.goBackToItems.bind(this);
        this.updateQuantity = this.updateQuantity.bind(this);
        this.closeSession = this.closeSession.bind(this);
        this.closeSessionCallback = this.closeSessionCallback.bind(this);
        this.checkGhostItems = this.checkGhostItems.bind(this);
        this.playFailure = this.playFailure.bind(this);
        this.playSuccess = this.playSuccess.bind(this);
        this.playAudio = this.playAudio.bind(this);
        this.playScanSlot = this.playScanSlot.bind(this);
        
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleSubmit.bind(this));
    }

    //Remove listener when component unmounts
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleSubmit.bind(this));
    }

    focusInput(fieldId) {
        if (!this.state.showDialog) {
            const inputField = document.getElementById(fieldId);
            if (inputField) {
                inputField.focus();
            }
        }
    }

    showConfirm(title, message, buttonTextPositive, buttonTextNegative, positiveFunction, negativeFunction, hideSubmit = false) {
        var buttons = [{
            label: buttonTextNegative,
            onClick: negativeFunction
        }];
        if (!hideSubmit) {
            buttons.push({
                label: buttonTextPositive,
                onClick: positiveFunction
            });
        }

        const options = {
            title: title,
            message: message,
            buttons: buttons,
            childrenElement: () => <div />,
            closeOnEscape: false,
            closeOnClickOutside: false,
            willUnmount: () => { },
            afterClose: () => { },
            onClickOutside: () => { },
            onKeypressEscape: () => { },
            overlayClassName: "confirm-message"
        };

        confirmAlert(options);
    }

    handleSubmit(e) {
        const stage = this.state.stage;
        //check if enter is pressed
        if (e.keyCode === 13) {
            if (stage === "putawayCart" && this.state.putawayCart) {
                //scan putaway cart
                this.startLoading();
                setTimeout(() => {
                    this.scanPutawayCart();
                }, 100);
            }
            else if (stage === "putawayItem" && this.state.putawayItem) {
                this.startLoading();
                setTimeout(() => {
                    this.scanPutawayItem()
                }, 100);
            }
            else if (stage === "putawayBin" && this.state.putawayBin) {
                //scan putaway bin
                const scanInput = this.state.putawayBin;
                const selectedPutawayItem = this.state.selectedPutawayItem;
                const maxQty = selectedPutawayItem.qty;
                //if they scan the item again, up the count
                if (selectedPutawayItem.upcs.indexOf(scanInput) > -1) {
                    const newQty = this.state.putawayQty + 1;
                    if (newQty <= maxQty) {
                        this.setState({
                            putawayQty: newQty,
                            putawayBin: ""
                        });
                        const qtyField = document.getElementById('qty-edit-input');
                        if (qtyField) {
                            //set qty field
                            qtyField.value = newQty;
                            this.playAudio("audio-element-coin");
                        }
                    }
                    else {
                        this.playFailure();
                        this.setState({
                            putawayQty: this.state.putawayQty,
                            putawayBin: ""
                        });
                        alert("You do not need any more of this item. You only need " + maxQty);
                    }
                }
                else {
                    this.startLoading();
                    this.closeDialog();
                    setTimeout(() => {
                        this.scanPutawayBin()
                    }, 100);
                }
            }
        }
    }

    resetState() {
        this.setState({
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false,
            putawayLocation: {},
            putawayCart: "",
            putawayItem: "",
            putawayBin: "",
            putawayQty: 1,
            putawayItems: [],
            selectedPutawayItem: {},
            putawayBin: {},
            binTransferId: null,
            stage: "putawayCart"
        });
        
    }

    closeDialog() {
        this.setState({
            showDialog: false,
            dialogFullScreen: false,
            dialogContent: "",
            dialogTitle: "",
            isErrorMessage: false,
            stage: this.state.putawayItems.length > 0 ? "putawayItem" : "putawayCart"
        });
        //find input field and focus on it
        if (this.state.stage === "putawayCart") {
            this.focusInput('putawayCart');
        }
        else if (this.state.stage === "putawayItem") {
            this.focusInput('putawayItem');
        }
        else if (this.state.stage === "putawayBin") {
            this.focusInput('putawayBin');
        }
    }

    startLoading() {
        this.setState({
            loading: true
        });
    }

    stopLoading() {
        this.setState({
            loading: false
        });
    }

    displayError(title, message) {
        this.playFailure();
        this.setState({
            dialogContent: message,
            dialogTitle: title,
            showDialog: true,
            isErrorMessage: true,
            actionDialog: false
        });
    }

    updateInputValue(e) {
        let value = e.target.value;
        value = value.toUpperCase();
        let fieldId = e.target.id;
        this.setState({
            [fieldId]: value
        });
        console.log(this.state);
    }

    async scanPutawayCart() {
        const putawayCart = this.state.putawayCart;
        await this.props.makeRESTCall(
            'byuwmsbinputaway?putawayCart=' + putawayCart + "&location=3",
            'get',
            null,
            (PutawayCartLookupResponse) => {
                console.log("PutawayCartLookupResponse", PutawayCartLookupResponse);
                if (PutawayCartLookupResponse.success && PutawayCartLookupResponse.binIsValid) {
                    if (PutawayCartLookupResponse.binItems.length > 0) {
                        this.setState({
                            putawayItems: PutawayCartLookupResponse.binItems,
                            stage: "putawayItem",
                            putawayLocation: PutawayCartLookupResponse.putawayLocation,
                            putawayBinId: PutawayCartLookupResponse.binId
                        });
                    }
                    else {
                        this.setState({
                            dialogContent: "The putaway cart scanned is empty. Please try again.",
                            dialogTitle: "Empty Putaway Cart - " + putawayCart,
                            showDialog: true,
                            isErrorMessage: false,
                            putawayCart: "",
                            putawayBinId: ""
                        });
                    }
                }
                else {
                    this.setState({
                        dialogContent: "The putaway cart scanned is not valid. Please try again.",
                        dialogTitle: "Invalid Putaway Cart - " + putawayCart,
                        showDialog: true,
                        isErrorMessage: true,
                        putawayCart: "",
                        putawayBinId: ""
                    });
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
    }

    async scanPutawayItem() {
        const putawayItem = this.state.putawayItem;
        const putawayItems = this.state.putawayItems;
        const selectedPutawayItem = putawayItems.find(item => item.upcs.indexOf(putawayItem) > -1);
        if (selectedPutawayItem) {
            const uom = selectedPutawayItem.unitOfMeasureInfo[putawayItem]?.uom;
            const uomText = selectedPutawayItem.unitOfMeasureInfo[putawayItem]?.uomText;
            if (uom !== selectedPutawayItem.stockUnit) {
                this.playFailure();
                alert("You must put " + selectedPutawayItem.displayname + " away as " + selectedPutawayItem.stockUnitText + " not as a " + uomText);
            }
            else if (selectedPutawayItem.qty === 0) {
                this.playFailure();
                alert("This item has already been putaway. Please try again.");
            }
            else {
                const itemQty = await this.getBinItemQty(this.state.putawayBinId, selectedPutawayItem.itemId, selectedPutawayItem.qty);
                selectedPutawayItem.qty = itemQty;
                putawayItems[putawayItems.findIndex(item => item.itemId == selectedPutawayItem.itemId)] = selectedPutawayItem;
                this.setState({
                    selectedPutawayItem: selectedPutawayItem,
                    putawayItems: putawayItems
                });
                this.putItemInBin();
            }
        }
        else {
            this.playFailure();
            alert("The item scanned is not in the putaway cart. Please try again.");
        }
        this.setState({
            putawayItem: ""
        })
        this.stopLoading();
    }

    async scanPutawayBin() {
        const putawayBin = this.state.putawayBin;
        let selectedPutawayItem = this.state.selectedPutawayItem;
        const qty = this.state.putawayQty;
        const postData = {
            newBin: putawayBin,
            currBin: this.state.putawayCart, //We should have the ID already
            location: this.state.putawayLocation.id,
            itemId: selectedPutawayItem.itemId,
            qty: qty,
            binTransferId: this.state.binTransferId
        };
        await this.props.makeRESTCall(
            'byuwmsbinputaway',
            'post',
            postData,
            (response) => {
                if (response.success) {
                    selectedPutawayItem.qty = selectedPutawayItem.qty - qty;
                    selectedPutawayItem.quantityPutaway = selectedPutawayItem.quantityPutaway + qty;
                    selectedPutawayItem.putawayInfo[putawayBin] = (selectedPutawayItem.putawayInfo[putawayBin] ?? 0) + qty
                    let binInfo = selectedPutawayItem.binInfo;
                    if (binInfo) {
                        const binIndex = binInfo.findIndex(bin => bin.binNumber === putawayBin);
                        if (binIndex > -1) {
                            binInfo[binIndex].qty = binInfo[binIndex].qty + qty;
                        }
                        else {
                            binInfo.push({
                                binNumber: putawayBin,
                                qty: qty
                            });
                        }
                    } 
                    selectedPutawayItem.binInfo = binInfo;
                    let putawayItems = this.state.putawayItems;
                    putawayItems[putawayItems.findIndex(item => item.itemId == selectedPutawayItem.itemId)] = selectedPutawayItem;
                    this.setState({
                        putawayItem: "",
                        putawayQty: 1,
                        putawayBin: "",
                        selectedPutawayItem: {},
                        putawayItems: putawayItems,
                        binTransferId: response.binTransferId
                    });
                    this.playSuccess();
                }
                else {
                    this.playFailure();
                    alert(response.message);
                    this.putItemInBin();
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
    }

    async getBinItemQty(binNumber, itemId, originalQty) {
        let qty = 0;
        await this.props.makeRESTCall(
            'byuwmsbinputawayqtylookup?binNumber=' + binNumber + '&itemId=' + itemId,
            'get',
            null,
            (binItemQtyLookupResponse) => {
                console.log("binItemQtyLookupResponse", binItemQtyLookupResponse);
                if (binItemQtyLookupResponse.success) {
                    qty = binItemQtyLookupResponse.binQty;
                }
                else {
                    alert("There was an error confirming the qty of this item. Please contact IT.");
                    qty = originalQty;
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
        return qty;
    }

    putItemInBin() {
        this.setState({
            stage: "putawayBin",
            putawayBin: ""
        })
    }

    goBackToItems() {
        this.setState({
            stage: "putawayItem",
            putawayItem: ""
        });
    }

    updateQuantity(newQty) {
        console.log("UPDATING QTY", newQty);
        this.setState({
            putawayQty: newQty
        });
    }

     closeSession() {
         this.startLoading();
        setTimeout(() => {
                this.closeSessionCallback();
            }, 100);
    }

    async closeSessionCallback() {
        let allItemsPutaway = false;
        await this.props.makeRESTCall(
            'byuwmsbinputaway?putawayCart=' + this.state.putawayCart + "&location=3",
            'get',
            null,
            (PutawayCartLookupResponse) => {
                if (PutawayCartLookupResponse.success) {
                    allItemsPutaway = PutawayCartLookupResponse.binItems.length === 0;
                }
                else {
                    alert("There was an error confirming this carts status. Please contact IT.")
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
        if (!allItemsPutaway) {
            this.showConfirm(
                "Verify Cart is Empty",
                "Are there still items on the cart?",
                "Yes",
                "No",
                () => {
                    this.resetState();
                },
                () => {
                    setTimeout(
                        this.checkGhostItems(),
                        1000
                    )
                }
            );
        }
        else {
            this.resetState();
        }
    }

    checkGhostItems() {
        this.playAudio('audio-element-ghost');
        alert("This cart has ghost items. Please report this to your supervisor");
        this.resetState();
    }


    playFailure() {
        const audioElbadISBN = document.getElementsByClassName("audio-element-failure")[0];
        if (audioElbadISBN.paused) {
            audioElbadISBN.play();
        } else {
            audioElbadISBN.currentTime = 0
        }
    }

    playSuccess() {
        const audioEl = document.getElementsByClassName("audio-element")[0];
        if (audioEl.paused) {
            audioEl.play();
        } else {
            audioEl.currentTime = 0
        }
    }

    playAudio(audioId) {
        const myAudio = document.getElementsByClassName(audioId)[0];
        if (myAudio.paused) {
            myAudio.play();
        } else {
            myAudio.currentTime = 0
        }
    }

    playScanSlot() {
        const audioEl = document.getElementsByClassName("audio-element-scan-slot")[0];
        if (audioEl.paused) {
            audioEl.play();
        } else {
            audioEl.currentTime = 0
        }
    }
        

    /*
        Default to Warehouse (Only place with bins)
        Scan a putaway cart
        Show list of items to putaway (qty)
        Scan an item/pick an item
        Pick an item QTY
        Scan a bin to put the item in
        Place items in bin
        Repeat until all items are putaway
    */

    render() {
        console.log("STUFF", this.state.putawayItems);
        console.log("this.state.putawayItems?.length", this.state.putawayItems?.length);
        return (
            <>
                {
                    this.state.loading
                    &&
                    <Loader />
                }
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                <Audio />
                <div>
                    {
                        this.state.stage === "putawayCart"
                        &&
                        <ScanPutawayCart
                            putawayCart={this.state.putawayCart}
                            scanPutawayCart={this.scanPutawayCart}
                            focusInput={this.focusInput}
                            updateInputValue={this.updateInputValue}
                        />
                    }
                    {
                        this.state.stage === "putawayItem"
                        &&
                        <ScanItems
                            putawayItem={this.state.putawayItem}
                            putawayItems={this.state.putawayItems}
                            closeSession={this.closeSession}
                            putawayCart={this.state.putawayCart}
                            scanPutawayItem={this.scanPutawayItem}
                            updateInputValue={this.updateInputValue}
                            focusInput={this.focusInput}
                        />
                    }
                    {
                        this.state.stage === "putawayBin"
                        &&
                        <ScanPutawayBin
                            putawayBin={this.state.putawayBin}
                            putawayItem={this.state.selectedPutawayItem}
                            scanPutawayBin={this.scanPutawayBin}
                            focusInput={this.focusInput}
                            updateInputValue={this.updateInputValue}
                            updateQuantity={this.updateQuantity}
                            putawayQty={this.state.putawayQty}
                            goBackToItems={this.goBackToItems}
                        />
                    }
                </div>
            </>
            
        );
    }
}
